import './App.css';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import ItineraryPage from './pages/Itinerary';
import About from './pages/About';
import Cancellation from './pages/Cancellation';
import Search from './pages/Search';
import Contact from './pages/Contact';
import EnquiryPage from './pages/EnquiryPage';
import ResponsiveHeader from './components/ResponsiveHeader';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Destinations from './pages/Destinations';
import AdminPage from './pages/admin';
import React from 'react';

function AppContent() {
  const location = useLocation();
  const showResponsiveHeader = location.pathname === '/enquiry';

  return (
    <div className="App">
      {showResponsiveHeader && <ResponsiveHeader />}
      <Routes>
        <Route path="/itinerary/:id" element={<ItineraryPage />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/search" element={<Search />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/enquiry" element={<EnquiryPage />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/cancellation" element={<Cancellation />} />
        <Route path="/destinations" element={<Destinations />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
